import React, { useEffect, useRef } from "react"
import { DadosItemSelecao } from "./DadosItemSelecao"
import clsx from 'clsx'

const estilos = require('./selecao-com-filtro.module.scss').default

export type ItemSelecaoProps = {
    item: DadosItemSelecao
    onItemSelecionado: () => void
    isSelecionado: boolean
    containerRef:HTMLDivElement
    id?: string
}

export const ItemSelecao = (props: ItemSelecaoProps) => {

    const selectedItemRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (selectedItemRef.current && props.containerRef) {
            const containerHeight = props.containerRef.clientHeight;
            const selectedHeight = selectedItemRef.current.clientHeight;
            const selectedOffsetTop = selectedItemRef.current.offsetTop;
            const scrollTop = selectedOffsetTop - containerHeight / 2 + selectedHeight / 2;

            props.containerRef.scrollTo({ top: scrollTop });
        }
    }, [props.isSelecionado]); 

    return <>
        <div
            ref={props.isSelecionado ? selectedItemRef : undefined}
            className={clsx("_bg-white _border-solid _border _border-collapse _cursor-pointer _pt-2 _pb-2 _pl-4", estilos.itemSelecao, props.isSelecionado ? "_bg-[#CCC]" : "")}
            onClick={() => props.onItemSelecionado()}
            id={props.id ?  `${props.id}_ItemSelecao_${props.item.chave}` : undefined}
            key={props.id ?  `${props.id}_ItemSelecao_${props.item.chave}` : undefined}
        >
            {props.item.valor}
        </div>
    </>
}